import { Avatar, Box, Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import type { FC } from 'react';
import useApplyTranslation from 'hooks/useApplyTranslation';

interface ConfirmModalProp {
    title: string | React.ReactNode;
    content: string | React.ReactNode;
    open: boolean;
    type?: string | 'warning' | 'success' | 'error';
    onConfirm: () => void;
    onClose: () => void;
}

const ConfirmModal: FC<ConfirmModalProp> = (props) => {
    const { open, onClose, onConfirm, title, content, type = 'warning', ...other } = props;

    const translatedWords = useApplyTranslation();
    return (
        <Dialog open={open} onClose={onClose} {...other}>
            <DialogContent>
                <Box sx={{ display: 'flex' }}>
                    <Avatar
                        sx={{
                            backgroundColor: (theme) => alpha(theme.palette.error.main, 0.08),
                            color: `${type}.main`,
                            mr: 2,
                        }}
                    >
                        {type === 'error' && <ErrorOutlineIcon />}
                        {type === 'warning' && <WarningIcon />}
                        {type === 'success' && <HelpOutlineIcon />}
                    </Avatar>
                    <Box>
                        <Typography color="textPrimary" variant="h5">
                            {title}
                        </Typography>
                        <Typography color="textSecondary" sx={{ mt: 1 }} variant="body2">
                            {content}
                        </Typography>
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
                <Button color="primary" sx={{ mr: 1 }} variant="outlined" onClick={onClose}>
                    {translatedWords.answer_no}
                </Button>
                <Button
                    sx={{ backgroundColor: 'error.main', '&:hover': { backgroundColor: 'error.dark' } }}
                    variant="contained"
                    onClick={onConfirm}
                >
                    {translatedWords.answer_yes}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmModal;

